import Vehicles from "./mocks/vehicles.json";

export const fetchVehicles = () => Vehicles;
